export type NotificationFeedState = 'loading' | 'error' | 'empty' | 'list';

export function resolveFeedState(
  items: unknown[] | undefined,
  isLoading: boolean,
  isError: boolean,
): NotificationFeedState {
  if (items !== undefined) {
    return items.length > 0 ? 'list' : 'empty';
  }

  if (isLoading) return 'loading';
  if (isError) return 'error';
  return 'empty';
}
